import type { NotificationGroup } from '@/lib/api/generated/model';

import type { InboxQuery } from './pageFilter';

/** What the inbox is showing; part of the list's key. */
export interface InboxFilter {
  unread?: boolean;
  group?: NotificationGroup;
  workspaceId?: string;
  /** Only what was archived (spec 135 US5). */
  archived?: boolean;
}

/** Every notifications query sits under `notifications`, so one invalidation reaches all. */
export const notificationKeys = {
  all: ['notifications'] as const,
  count: () => ['notifications', 'count'] as const,
  lists: () => ['notifications', 'list'] as const,
  list: (filter: InboxFilter) => ['notifications', 'list', filter] as const,
  /**
   * The notifications page's list (spec 147). Not under `lists()`: the stream
   * refreshes the bell's lists on every arrival, and the page must hold still
   * and say "N new" instead (FR-007).
   */
  pages: () => ['notifications', 'page'] as const,
  page: (query: InboxQuery) => ['notifications', 'page', query] as const,
  /** How many a filter matches, for a whole-filter confirmation. */
  matchings: () => ['notifications', 'matching'] as const,
  matching: (query: InboxQuery) =>
    ['notifications', 'matching', query] as const,
  /** How many matching arrived since the page loaded (spec 147 FR-007). */
  arrived: (query: InboxQuery, arrivalSeq: number) =>
    ['notifications', 'matching', 'arrived', query, arrivalSeq] as const,
  preferences: () => ['notifications', 'preferences'] as const,
  follow: (workspaceId: string, taskId: string) =>
    ['notifications', 'follow', workspaceId, taskId] as const,
};
